import React from 'react';
import PropTypes from 'prop-types';

import voucherIcon from '../../../images/banner-promo/voucher.svg';

import {
  BonusAmount,
  BonusAmountWrapper,
  BonusGroup,
  VoucherIcon,
  VoucherInner,
  VoucherRotate,
  VoucherWrapper,
} from './styles';

const BonusValue = ({ amount }) => (
  <BonusGroup data-node-id="2242:5442">
    <VoucherWrapper data-node-id="2242:5443">
      <VoucherRotate>
        <VoucherInner>
          <VoucherIcon src={voucherIcon} alt="" aria-hidden />
        </VoucherInner>
      </VoucherRotate>
    </VoucherWrapper>

    <BonusAmountWrapper data-node-id="2242:5445">
      <BonusAmount>{amount}</BonusAmount>
    </BonusAmountWrapper>
  </BonusGroup>
);

BonusValue.propTypes = {
  amount: PropTypes.string.isRequired,
};

export default BonusValue;
